import TrackingSalesActions from './actions';

const INITIAL_STATE = {
  data: {},
  dataTracking: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  helperTrackingSales:null,
  timeline:null,
  details:null,
  loadingDetails:false
};

function TrackingSalesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TrackingSalesActions.RESET_DATA:
      return INITIAL_STATE;
    case TrackingSalesActions.NEW_DATA:
      return { ...state, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case TrackingSalesActions.GET_HELPER_REPORTVISIT:
        return { 
          ...state,
          isProcessing: false, 
          helperTrackingSales: action.payload 
        };
      case TrackingSalesActions.GET_DATA:
        return { 
          ...state,
          isError: false,
          isProcessing: true, 
      };
      case TrackingSalesActions.SET_TRACKING:
        return { 
          ...state,
          isProcessing: false, 
          isError: false,
          dataTracking: action.payload 
        };
      case TrackingSalesActions.ERROR_DATA:
          return { 
            ...state, errorInternal:false, 
            isError: true,onSubmit:false,  
            errorMessage: action.payload,
            isProcessing:false 
        };
      case TrackingSalesActions.LOADED_DETAILS:
        return { 
          ...state,
          details: action.payload, 
          loadingDetails: false
        };
      case TrackingSalesActions.LOADING_DETAILS:
        return { 
          ...state,
          details: null, 
          loadingDetails: true
        };
    default:
      return state;
    }
}


export default TrackingSalesReducer;
